// assets
import settingsIcon from "../assets/images/icons/settings.svg";

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const setup = {
  id: "setup",
  type: "group",
  children: [
    {
      id: "setup",
      title: "Setup",
      type: "collapse",
      icon: settingsIcon,
      children: [
        {
          id: "EM-TrackSettings",
          title: "EM/e Track Settings",
          type: "item",
          url: "/setup/EM-TrackSettings",
          breadcrumbs: false,
          featureName: 'EMSetup',
        },
        {
          id: "ERPProducts",
          title: "ERP Products",
          type: "item",
          url: "/setup/ERPProducts",
          breadcrumbs: false,
          featureName: 'EMSetup',
        },
        {
          id: "OOSBillSets",
          title: "OOS Bill Sets",
          type: "item",
          url: "/setup/OOSBillSets",
          breadcrumbs: false,
          featureName: 'EMSetup',
        },
        {
          id: "PriceBook",
          title: "Price Book",
          type: "item",
          url: "/setup/PriceBook",
          breadcrumbs: false,
          featureName: 'EMSetup',
        },
        {
          id: "ServiceLevels",
          title: "Service Levels",
          type: "item",
          url: "/setup/ServiceLevels",
          breadcrumbs: false,
          featureName: 'EMSetup',
        },
        {
          id: "Warranties",
          title: "Warranties",
          type: "item",
          url: "/setup/Warranties",
          breadcrumbs: false,
          featureName: 'EMSetup',
        },
      ],
    },
  ],
};

export default setup;
